import { render, staticRenderFns } from "./ApplicantLogin.vue?vue&type=template&id=1206e7f1&scoped=true&"
import script from "../../services/applicant/applicant-login.js?vue&type=script&lang=js&"
export * from "../../services/applicant/applicant-login.js?vue&type=script&lang=js&"
import style0 from "./ApplicantLogin.vue?vue&type=style&index=0&id=1206e7f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1206e7f1",
  null
  
)

export default component.exports